import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LexiconModule } from '@galaxy/lexicon';

@Component({
  selector: 'meeting-analysis-meeting-summary',
  imports: [CommonModule, LexiconModule],
  templateUrl: './meeting-summary.component.html',
  styleUrl: './meeting-summary.component.scss',
})
export class MeetingSummaryComponent {
  summary = input.required<string>();
  keyTakeaways = input.required<string[]>();
  actionItems = input.required<string[]>();
}
